import { render, staticRenderFns } from "./KCircularLoader.vue?vue&type=template&id=c804ee94&scoped=true&"
import script from "./KCircularLoader.vue?vue&type=script&lang=js&"
export * from "./KCircularLoader.vue?vue&type=script&lang=js&"
import style0 from "./KCircularLoader.vue?vue&type=style&index=0&id=c804ee94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c804ee94",
  null
  
)

export default component.exports